// Brand Google Maps styling — muted palette that matches the app
// (soft greens/greys, desaturated water, POIs hidden), expressed for BOTH
// interactive maps and static map images. Ported from the design refresh.

// Interactive maps: pass as `options.styles` on a google.maps.Map.
export const BRAND_MAP_STYLE = [
  { elementType: 'geometry', stylers: [{ color: '#eef1ea' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#5b625c' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#ffffff' }, { weight: 2 }] },
  { featureType: 'poi', stylers: [{ visibility: 'off' }] },
  { featureType: 'transit', stylers: [{ visibility: 'off' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
  { featureType: 'road', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#e6e3d8' }] },
  { featureType: 'landscape.natural', stylers: [{ color: '#e3e9d9' }] },
  { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#d5e6c8' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#c7d6d4' }] },
];

// Dark-theme variant for interactive maps (used when data-theme="option2"),
// so the map doesn't glare inside a dark-themed modal.
export const BRAND_MAP_STYLE_DARK = [
  { elementType: 'geometry', stylers: [{ color: '#2b3138' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#9aa5ad' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#1f242a' }, { weight: 2 }] },
  { featureType: 'poi', stylers: [{ visibility: 'off' }] },
  { featureType: 'transit', stylers: [{ visibility: 'off' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#3a4149' }] },
  { featureType: 'road', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#454d56' }] },
  { featureType: 'landscape.natural', stylers: [{ color: '#2f363d' }] },
  { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#33403a' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#1f2933' }] },
];

// Static Maps API: same look expressed as repeated `style=` query params.
// Pipes are URL-encoded (%7C); colons/values are accepted raw by the Static Maps API.
const STATIC_RULES = [
  'element:geometry|color:0xeef1ea',
  'element:labels.text.fill|color:0x5b625c',
  'element:labels.text.stroke|color:0xffffff',
  'feature:poi|visibility:off',
  'feature:transit|visibility:off',
  'feature:road|element:geometry|color:0xffffff',
  'feature:road|element:labels.icon|visibility:off',
  'feature:road.highway|element:geometry|color:0xe6e3d8',
  'feature:landscape.natural|color:0xe3e9d9',
  'feature:poi.park|element:geometry|color:0xd5e6c8',
  'feature:water|element:geometry|color:0xc7d6d4',
];

export const STATIC_MAP_STYLE_PARAMS = STATIC_RULES
  .map((r) => 'style=' + r.replace(/\|/g, '%7C'))
  .join('&');

// Append the brand style to an existing Google Static Maps URL.
// Idempotent and safe to wrap any src: returns the input unchanged for
// falsy values, non-Google URLs, or URLs that already carry a style.
export function styleStaticMapUrl(url) {
  if (!url || typeof url !== 'string') return url;
  if (!url.includes('maps.googleapis.com/maps/api/staticmap')) return url;
  let out = url;
  // Brand the route polyline green when it carries no explicit color yet.
  if (out.includes('path=enc:')) {
    out = out.replace('path=enc:', 'path=color:0x9fc131%7Cweight:4%7Cenc:');
  }
  // Append the brand map style once (idempotent).
  if (!out.includes('style=')) {
    out = out + '&' + STATIC_MAP_STYLE_PARAMS;
  }
  return out;
}
